import React from "react";
import styled from "styled-components";
import { Spin, Alert } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const LoadingIcon = () => (
  <Spin
    indicator={
      <LoadingOutlined style={{ fontSize: 18, color: "#1070B6" }} spin />
    }
  />
);

export const LoadingText = <Alert type="info" message="Loading..." />;

const CenteredLoadingContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
`;

export const CenteredLoading = () => (
  <CenteredLoadingContainer>
    <LoadingIcon />
  </CenteredLoadingContainer>
);

const StyledFullscreenLoading = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const FullscreenLoading = (
  <StyledFullscreenLoading>
    <LoadingIcon />
  </StyledFullscreenLoading>
);
